import React from 'react';
import {
  getEmailType,
  ensureUniqueReferences,
  getReferences,
  isDraftMessage,
} from '../utils/emailTypeUtils';

export interface UseEmailProcessingProps {
  message?: any;
  mode?: 'new' | 'reply' | 'reply-single' | 'forward';
  setCurrentDraftMsgId: (value: string | null) => void;
}

export const useEmailProcessing = ({
  message,
  mode = 'new',
  setCurrentDraftMsgId,
}: UseEmailProcessingProps) => {
  const prevComposeKeyRef = React.useRef<string | null>(null);

  // Update currentDraftMsgId when opening an existing draft, or reset when the user
  // actually switches thread/mode — not when the parent passes a new message object
  // for the same msgId (e.g. quote attachments merged into message in a modal).
  React.useEffect(() => {
    if (message?.msgId && isDraftMessage(message)) {
      setCurrentDraftMsgId(message.msgId);
      prevComposeKeyRef.current = `draft:${message.msgId}`;
      return;
    }

    if (
      mode === 'new' ||
      mode === 'reply' ||
      mode === 'reply-single' ||
      mode === 'forward'
    ) {
      const composeKey =
        mode === 'new'
          ? `new:${message?.msgId ?? ''}`
          : `${mode}:${message?.msgId ?? ''}`;

      if (prevComposeKeyRef.current !== composeKey) {
        prevComposeKeyRef.current = composeKey;
        setCurrentDraftMsgId(null);
      }
    }
  }, [message, mode, setCurrentDraftMsgId]);

  return {
    getEmailType: () => getEmailType(mode, message),
    getReferences: () => getReferences(message, mode),
    ensureUniqueReferences,
  };
};
